const UserComponentManager = {
  init: function() {
    this.components = [];
  },
  add: function(component) {
    this.components.push(component);
  },
  flush: function() {
    this.components.forEach((component) => {
      component.flush();
    });
  },
  update: function(dt) {
    this.components.forEach((component) => {
      component.systemUpdate(dt);
      component.updateChildren(dt);
    });
  },
  createComponent: function(name) {
    const c = {
      name: name,
      active: {},
      init: function() {
      },
      flush: function() {
        // console.log("FLUSHING COMPONENT: " + name);
        for (const key in this.active) {
          if (Object.hasOwnProperty.call(this.active, key)) {
            let obj = this.active[key];
            console.log('component: ' + name + ',  delete: ' + key);
            delete this.active[key];
            obj = null;
          }
        }
        this.active = {};
      },
      systemUpdate: function(dt) { }, // System
      do: function(entity, dt) { }, // individual component update

      updateChildren: function(dt) {
        for (const key in this.active) {
          if (Object.hasOwnProperty.call(this.active, key)) {
            this.do(this.active[key], dt);
          }
        }
      },

      add: function(entity, paramsObj) {
        paramsObj.entity = entity;
        this.active[entity.name] = paramsObj;
      },
      remove: function(entity) {
        delete this.active[entity.name];
      },
      setParam: function(entity, param, value) {
        this.active[entity.name][param] = value;
      },
    };
    this.components.push(c);
    return c;
  },
};
UserComponentManager.init();
export {UserComponentManager};
